/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AnalyticsIds} from '@ion/core/src/analytics/types';
import {BoundaryFilter as BoundariesFilter} from '@ion/dls/src/components/menus/BoundaryFilterMegaMenu';
import {Filters} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

interface BoundaryFilterParamsType extends FilterParamsType {
  onClickBoundaryList?: Function;
  onApplyBoundary?: Function;
  disableClear?: boolean;
  selectFieldMinWidth?: string;
}

export const BoundaryFilter = ({
  onClickBoundaryList,
  onApplyBoundary,
  toggleView,
  selectFieldMinWidth,
  disableClear = false
}: BoundaryFilterParamsType) => (
  <BoundariesFilter elementId={AnalyticsIds.assetHistoryBoundaryFilter}
    name={Filters.boundary}
    onBoundaryChoose={onClickBoundaryList}
    onClear={onApplyBoundary}
    selectFieldMinWidth={selectFieldMinWidth}
    onCancel={toggleView}
    onMenuClose={toggleView}
    disableClear={disableClear}
    minMenuWidth='350px'/>
);
